import { client } from '../../client';
import {
  StudentFragment,
  StudentsByClassDocument,
  StudentsByClassQuery,
  StudentsByClassQueryVariables,
  StudentsMyClassDocument,
  StudentsMyClassQuery,
  StudentsMyClassQueryVariables,
} from '../types';

// [Shared] Get available books from a subject
export async function getClassStudents(variables: StudentsByClassQueryVariables): Promise<Array<StudentFragment>> {
  try {
    const result = await client.query<StudentsByClassQuery, StudentsByClassQueryVariables>({
      query: StudentsByClassDocument,
      variables,
    });
    return result.data.students;
  } catch (error) {
    throw Error(error);
  }
}

export async function getMyClassStudents(): Promise<Array<StudentFragment>> {
  try {
    const { data } = await client.query<StudentsMyClassQuery, StudentsMyClassQueryVariables>({
      query: StudentsMyClassDocument,
    });
    let studentsFragments: Array<StudentFragment> = [];
    data.view_class_student.map(classStudent => {
      const newFragment: Readonly<StudentFragment> = {
        id: classStudent.student.id,
        user: classStudent.student.user,
      };
      studentsFragments.push(newFragment);
    });
    return studentsFragments;
  } catch (error) {
    throw new Error(error);
  }
}
